<template>
  <div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Questions</h2>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-12">
        <div class="intro-y box p-5">
          <div>
            <label>Quiz Title</label>
            <input
              v-model="quiz.quiz_title"
              type="text"
              class="input w-full border mt-2"
              placeholder="Enter the name of the quiz"
            />
          </div>
          <div class="mt-2">
            <label>Class</label>
            <div class="mt-2">
              <input
                  v-model="quiz.domain"
                  type="text"
                  class="input w-full border"
                  placeholder="Grade I / Grade II ..."
              />
            </div>
          </div>
          <div class="mt-2">
            <label>Subject</label>
            <div class="mt-2">
              <input
                  v-model="quiz.quiz_subject"
                  type="text"
                  class="input w-full border"
                  placeholder="Grade I / Grade II ..."
              />
            </div>
          </div>
          <div class="mt-2">
            <label>Difficulty</label>
            <div class="mt-2">
              <TailSelect
                  v-model="quiz.difficulty"
                  :options="{
                      hideSelected: true,
                      hideDisabled: true,
                      multiShowCount: false,
                      multiContainer: true,
                      classNames: 'w-full'
                    }"
                  single
              >
                <option value="Easy">Easy</option>
                <option value="Medium">Medium</option>
                <option value="Hard">Hard</option>
              </TailSelect>
            </div>
          </div>

          <div class="mt-3">
            <label>Time Required</label>
            <div class="relative mt-2">
              <input
                v-model="quiz_time"
                type="text"
                class="input w-full border"
                placeholder="Time"
              />
              <div
                class="absolute top-0 right-0 rounded-r h-full flex items-center justify-center bg-gray-100 dark:border-dark-4 border text-gray-600"
              >
                <TailSelect v-model="unit" single>
                  <option value="s">Second(s)</option>
                  <option value="m">Minute(s)</option>
                  <option value="h">Hour(s)</option>
                </TailSelect>
              </div>
            </div>
          </div>
          <div class="text-right mt-5">
            <button
              type="button"
              class="button w-24 bg-theme-1 text-white"
              @click="updateQues"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
    <Table
      class="mt-5"
      :quiz="quiz"
      :ques="ques"
      @quesAdded="getQuestionsByQuizID(quiz_id)"
      @add="addModal"
      @edit="editModal"
    ></Table>
    <t-modal
        v-model="isModal"
    >
      <ques-modal :data="quesModel" :isEditMode="quesModeIsEdit"
            @quesAdded="getQuestionsByQuizID(quiz_id)"
            :quiz="quiz"
            :ques="ques"
      ></ques-modal>
    </t-modal>
  </div>
</template>

<script>
import Table from "../../components/Core/UTableQuestions";
import QuesModal from "../../components/Core/UModalQues"
export default {
  components: {
    Table,
    QuesModal
  },
  data() {
    return {
      isModal: false,
      quesModel: {},
      quesModeIsEdit: false,
      cardImages: [
        "https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Coding+(2).jpg",
        "https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Coding.jpg",
        "https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/English.jpg",
        "https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Math-2.jpg",
        "https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Math.jpg",
        "https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Robotics-2.jpg",
        "https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Robotics.jpg",
        "https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/soft-skill.jpg",
        "https://upskill-files.s3.ap-southeast-1.amazonaws.com/quiz+/card+images/Stem.jpg"
      ],
      quiz_time: "",
      unit: "",
      model: {
        quiz_title: "",
        quiz_subject: "",
        time_required: "",
        status: ""
      },
      ques: [],
      quiz: {},
      quiz_id: ""
    };
  },
  created() {
    this.quiz_id = this.$route.params.quiz_id;
    this.getQuestionsByQuizID(this.quiz_id);
  },
  methods: {
    addModal(e) {
      this.quesModeIsEdit = false
      this.isModal = true
    },
    editModal(e) {
      this.quesModeIsEdit = true
      let ques = e.questions
      this.quesModel = ques
      this.isModal = true
    },
    updateQues() {
      this.quiz.time_required = this.quiz_time + this.unit;
      this.$upskill.orgUpdateQuiz(this.quiz).then(() => {
        window.alert("updated!");
      });
    },
    getQuestionsByQuizID(id) {
      this.$upskill.orgGetQuesByQuizID(id).then(res => {
        this.ques = res.data.question_data;
        this.quiz = res.data.quiz_data;
        this.unit = this.quiz.time_required[this.quiz.time_required.length - 1];
        this.quiz_time = this.quiz.time_required
          .split("")
          .slice(0, this.quiz.time_required.length - 1)
          .join("");
        this.isModal = false
      });
    }
  }
};
</script>
